import {View, ActivityIndicator} from 'react-native';
import React from 'react';
import {isMacOS, isWindows, isMobile, white} from '../../utils/utils';
import NorcatAlert from '../../utils/norcat_alert';
import {ProgressDialog} from '../../utils/progressDialog';

const NorcatWebAlert = props => {
   const {isApiLoading, message, onCallBack, showAlert} = props;
   return (
      <>
         {isApiLoading ? (
            isMobile || isMacOS || isWindows ? (
               <View
                  style={{
                     width: '100%',
                     height: '100%',
                     zIndex: 999,
                     justifyContent: 'center',
                     alignItems: 'center',
                     position: 'absolute',
                  }}>
                  <ActivityIndicator size="large" color={white} />
               </View>
            ) : (
               <ProgressDialog visible={isApiLoading && !isMobile} />
            )
         ) : (
            showAlert && (
               <NorcatAlert
                  actionPositive={true}
                  title="Alert!"
                  message={message}
                  buttonText={'OK'}
                  onCallBack={() => {
                     onCallBack();
                  }}
               />
            )
         )}
      </>
   );
};

export default NorcatWebAlert;
